import React, { useContext, useEffect, useState } from "react"
import {
  Chip,
  Button,
  Navbar,
  NavbarBrand,
  NavbarContent,
  DropdownItem,
  Dropdown,
  DropdownMenu,
  DropdownTrigger,
  Autocomplete,
  AutocompleteItem,
  Select,
  SelectItem,
} from "@heroui/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBars, faBarsStaggered, faCircleUser, faDiamond, faGem, faIdCard, faPowerOff, faRectangleList, faUserAlt, faUserGear } from "@fortawesome/free-solid-svg-icons"
import { useQueryClient } from "@tanstack/react-query"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { Link, useNavigate } from "react-router-dom"

import { LayoutContext } from "../contexts/LayoutContext.jsx"
import { setLogout } from "../state/authSlice.jsx"
import { apiRoute, linksUrl } from "../constants/enum.js"
import { resetCompCode, setYearId } from "../state/companySlice.jsx"
import { isMobile } from 'react-device-detect';
import { useFetchWithBody, usePost } from "../api/reactQueryCustomHooks.jsx"
import AcYearSelection from "./AcYearSelection.jsx"




export default function Nav() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { setShowSideNav } = useContext(LayoutContext)
  const { user } = useSelector((state) => state.auth)
  const queryClient = useQueryClient()
  const { compName } = useSelector((state) => state.company)


  const handleLogout = () => {
    dispatch(setLogout())
    dispatch(resetCompCode())
    queryClient.removeQueries()
    navigate(linksUrl.login)
  }
  const handleResetPassword = () => {
    navigate(linksUrl.resetPassword)

  }

  const funGetSubString = (str) => {
    if (str && str != "") {
      if (str.length > 19)
        return str.substring(0, 19) + ".."
      else
        return str
    }
    else
      return str
  }

  return (
    <>

      <Navbar maxWidth="2xl" height={"3rem"} className="z-[99] sticky bg-slate-800 " >

        <NavbarContent>
          <NavbarBrand className={`${isMobile?"text-xs":"text-md"}`}>
              <Link to={linksUrl.dashboard}>  <p className="font-bold  p-0 m-0 tracking-widest text-white ">
                <FontAwesomeIcon className={`${isMobile?"text-xl pr-2":"text-2xl pr-5"}`} icon={faGem} ></FontAwesomeIcon>
                DIAMAPP</p></Link>
          </NavbarBrand>
          <NavbarBrand className=" flex items-center gap-0 ">

            {/* <div className="mr-4 flex items-center gap-2" > */}
            <Button
              variant="light"
              isIconOnly
              aria-label="Like"
              size="sm"
              className="text-white bg-gray-600 bg-opacity-90"
              onPress={() => {
                setShowSideNav((prev) => !prev)
              }}
            >
              <FontAwesomeIcon icon={faBarsStaggered} size="xl" />
            </Button>

             <Link to={linksUrl.companies}>  
            <Chip radius="sm" variant="light" className="text-white  semi-bold uppercase" >
              {compName && compName.length == 1 ? funGetSubString(compName[0])
                : compName && compName.length > 1 ? funGetSubString(compName[0]) + " & Other" : user?.clientName}
            </Chip>
             </Link> 
          </NavbarBrand>
          {/* <NavbarBrand className="">
            {isMobile ? (

              <div className=" flex flex-wrap text-custom-text-white text-xs uppercase"
                style={{ fontSize: "0.6rem" }} >

                <div>  <Link to={linksUrl.companies}> {compName && compName.length > 0 ? funGetSubString(compName[0]) : ""}</Link></div>
                <div>  <Link to={linksUrl.companies}>{compName && compName.length > 1 ? " &Other" : ""}</Link></div>
              </div>

            ) :
              <div className=" flex text-custom-text-white uppercase"
                style={{ fontSize: "12px" }} >

                <div><Link to={linksUrl.companies}>  {compName && compName.length > 0 ? compName[0] : ""}</Link></div>
                <div><Link to={linksUrl.companies}>  {compName && compName.length > 1 ? " & Other" : ""}</Link></div>

              </div>
            }
          </NavbarBrand> */}
          {!isMobile ?
            <NavbarBrand>


              <AcYearSelection></AcYearSelection>

            </NavbarBrand>
            : ""}

        </NavbarContent>

        <NavbarContent as="div" className="items-center bg-slate-800 p-0 border-0 m-0 " justify="end">
          <Dropdown placement="bottom-end" className="bg-slate-700" radius="none" >
            <DropdownTrigger>

              <FontAwesomeIcon icon={faUserGear} size="xl" className="p-2 cursor-pointer text-custom-text-white bg-gray-600 opacity-90 rounded-md" />

            </DropdownTrigger>
            <DropdownMenu aria-label="Profile Actions" className="bg-white" variant="light" color={"warning"} size="sm">
              <DropdownItem key="profile" className="">

                <div className="font-semibold"><FontAwesomeIcon icon={faIdCard}></FontAwesomeIcon> {user?.username}</div>

              </DropdownItem>
              <DropdownItem>
                {user?.firstName} {user?.lastName}
              </DropdownItem>
              <DropdownItem key="ResetPassword" onPress={handleResetPassword} >
                Reset Password
                {/* <div onClick={handleResetPassword} >Reset Password</div> */}
                {/* <div><Link to={linksUrl.resetPassword} >Reset re Password</Link></div> */}
              </DropdownItem>
              <DropdownItem key="logout" className="text-slate-900 bg-gray-50 text-sm font-semibold" onPress={handleLogout}>
                <FontAwesomeIcon className="mr-3 font-semibold" icon={faPowerOff}></FontAwesomeIcon>Logout
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </NavbarContent>

      </Navbar>

      <div className=" fixed top-17 z-[39] w-full mx-auto " >
        {isMobile ?
          <div className="mx-auto bg-gradient-to-tl from-amber-300 to-amber-200  border-t-0 border-sky-800">
            <AcYearSelection></AcYearSelection></div> : ""}
      </div>
    </>
  )
}
